export enum PaymentProtectionEnum {
  SECURED = 'SECURED',
  RENEWAL = 'RENEWAL',
  SUSPENDED = 'SUSPENDED',
}
